import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';

/* global customElements */
class AccountControl extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		this.local = false;
		
		var accountControl = this;
		setTimeout(function(){
			accountControl.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var accountControl = this;
	
		var closeSection = ElementUtil.create({
			tag: 'dl-section-panel',
			style: 'margin-top: 10px',
			title: 'Close Account',
			children: [
				{
					tag: 'div',
					slot: 'content',
					children: [
						{
							tag: 'dl-action-button',
							permissions: ['ADMIN_BILLING_ACCOUNTS:CLOSE_OPEN_ACCOUNT'],
							children: [
								ElementUtil.makeIcon('vaadin:close', ' Close Account Next Cycle')
							],
							listeners: {
								click: function () {
									actionCloseAccount(false, false);
								}
							}
						},
						{
							tag: 'dl-action-button',
							style: 'margin-left: 10px;',
							permissions: ['ADMIN_BILLING_ACCOUNTS:CLOSE_OPEN_ACCOUNT'],
							children: [
								ElementUtil.makeIcon('vaadin:close', ' Close Account Now')
							],
							listeners: {
								click: function () {
									actionCloseAccount(true, false);
								}
							}
						},
						{
							tag: 'dl-action-button',
							style: 'margin-left: 10px;',
							permissions: ['ADMIN_BILLING_ACCOUNTS:CLOSE_OPEN_ACCOUNT'],
							children: [
								ElementUtil.makeIcon('vaadin:minus', ' Remove Close Request')
							],
							listeners: {
								click: function () {
									actionCloseAccount(false, true);
								}
							}
						}
					]
				}
			]
		});
		accountControl.append(closeSection);
	
		var management = ElementUtil.create({
			tag: 'dl-section-panel',
			style: 'margin-top: 10px',
			title: 'Management',
			children: [
				{
					tag: 'div',
					slot: 'content',
					children: [
						{
							tag: 'dl-action-button',			
							permissions: ['ADMIN_BILLING_ACCOUNTS:CLOSE_OPEN_ACCOUNT'],
							children:[
								ElementUtil.makeIcon('vaadin:share', ' Re-open Account')
							], 
							listeners: {
								click: function() {
									actionReopenAccount();
								}
							}
						},
						{
							tag: 'dl-action-button',
							style: 'margin-left: 10px;',
							permissions: ['ADMIN_BILLING_ACCOUNTS:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:minus-circle', ' Clear Account')
							], 
							listeners: {
								click: function() {
									actionClearAccount();
								}
							}
						},
						{
							tag: 'dl-action-button',
							style: 'margin-left: 10px;',
							permissions: ['ADMIN_BILLING_ACCOUNTS:SET_ACCOUNT_BALANCE'],
							children:[
								ElementUtil.makeIcon('vaadin:cash', ' Update Balance')
							], 
							listeners: {
								click: function() {
									actionSetAccountBalance();
								}
							}
						}						
					]
				}				
			]
		});
		accountControl.append(management);
		
		var actionCloseAccount = function(now, cancel) {
			var nowMessage = now ? 'Close Now' : 'Next Cycle';
			if (cancel) {
				nowMessage = 'Cancel Close Request next cycle';
			}
			
			var win = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Close Request - ' + nowMessage,
				icon: 'vaadin:close',
				width: 800,
				height: 200,
				listeners: {
					ready: function() {						
						win.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [											
										{
											tag: 'vaadin-text-field',
											label: 'Reason',											
											name: 'comment',
											colspan: 2,
											required: true,
											maxlength: 1024
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:check', ' Submit')
													],
													listeners: {
														click: function() {															
															
															formPanel.submitForm({
																preSubmit: function(data) {																		
																	return data;
																},
																actualCall: function(data) {																	
																	var options = {
																		now: now,
																		cancel: cancel
																	};
																	return BillingService.getAccountService().closeAccount(accountControl.detail.companyId, data, options);
																},
																success: function(data, responseData) {
																	var closeMessage = (now ? 'Closed Account' : 'Submitted Close Request');
																	
																	window.DL.MessageUtil.showToast('Success', closeMessage, {
																		theme: 'success',
																		position: 'top-stretch'
																	});																																		
																	win.close();
																}
																
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															win.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						win.addToContentElement(formPanel);			
					}
				}
			});
		};
		
		var actionReopenAccount = function() {
			
			var openWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Re-open Account',
				icon: 'vaadin:share',
				width: 800,
				height: 200,
				listeners: {
					ready: function() {						
						openWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [											
										{
											tag: 'vaadin-text-field',
											label: 'Reason',
											name: 'comment',
											colspan: 2,
											required: true,
											maxlength: 1024
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:share', ' Open')
													],
													listeners: {
														click: function() {															
															
															formPanel.submitForm({
																preSubmit: function(data) {																		
																	return data;
																},
																actualCall: function(data) {																	
																	return BillingService.getAccountService().reopenAccount(accountControl.detail.companyId, data);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Re-opened Account', {
																		theme: 'success',
																		position: 'top-stretch'
																	});																																		
																	openWin.close();
																}
																
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															openWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						openWin.addToContentElement(formPanel);
						
					}
				}
			});
			
		};
		
		var actionClearAccount = function() {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Clear',
				message: 'Are you sure you want to Remove ALL Products from this account? <br> Note: This does NOT remove any customer data.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = accountControl.showLoading('Clearing...');													
							
							BillingService.getAccountService().clearAccount(
								accountControl.detail.companyId
							).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Cleared Account', {									
									theme: 'success'
								});
								actionRefresh();
							}, function(){
								loadMask.remove();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});	
		};
		
		var actionSetAccountBalance = function() {
			var balanceWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Update Balance',
				icon: 'vaadin:cash',
				width: 800,
				height: 250,
				listeners: {
					ready: function() {						
						balanceWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [	
										{
											tag: 'vaadin-number-field',
											label: 'New Balance',
											name: 'newBalance',											
											required: true,
											min: -9999999,
											max: 9999999
										},
										{
											tag: 'vaadin-text-field',
											label: 'Reason',
											name: 'comment',											
											required: true,
											maxlength: 1024
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Update')
													],
													listeners: {
														click: function() {															
															
															formPanel.submitForm({
																preSubmit: function(data) {	
																	data.companyId = accountControl.detail.companyId;
																	return data;
																},
																actualCall: function(data) {																	
																	return BillingService.getAccountService().updateBalance(accountControl.detail.companyId, data);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Updated Balance', {
																		theme: 'success',
																		position: 'top-stretch'
																	});																																		
																	balanceWin.close();
																}
																
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															balanceWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						balanceWin.addToContentElement(formPanel);
						
					}
				}
			});
		};
				
	}

};
customElements.define('dl-account-account-control', AccountControl);
